import { GebaeudeAufGrundstueckDetailEntryMeta, GebaeudeVersionDetailEntryMeta } from '../../../core/av-api';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GebaeudeVersionDetailEntryVm {
  public showGeometrischerVerschnitt = false;

  constructor(
    public model: GebaeudeVersionDetailEntryMeta,
    public gebaeudeAufGrundstueckZuVersion: Array<GebaeudeAufGrundstueckDetailEntryMeta>,
    public lastVisible: boolean,
    public anzahlLIG: number,
    public anzahlSDR: number
  ) {
    this.showGeometrischerVerschnitt = !model.histInfo.bisTimePoint && lastVisible;
  }
}
